<template>
        <input type="text"
               class="input-text-scv-FRONTENDEX-MOBILE-APP searchIcon"
               v-bind:placeholder="placeholder"
               v-model="strInput"
               @keydown.enter="onEnterkeyDown" />
        <button v-show="'' != strInput" id="clear_button" class="clearButton" v-on:click="onClearButton"></button>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    @Options({
        props: {
            placeholder: { type: String, default: "検索" },// ウォーターマーク
        },
        emits: [
            /**
             * @brief	Enter
             * @param	string: 入力文字
             */
            "onEnterkeyDown",
            "keydown"
        ],
        watch: {
            strInput: {
                handler: function () {
                    this.$emit("onEnterkeyDown", this.strInput);  
                },
                deep: true,   // オブジェクトの監視
                immediate: false
            }
        },
    })
    /**
     * 検索アイコン付きエディットボックス（ただのMaskInputの拡張）
     */
    export default class SearchInputMobileApp extends Vue {

        private strInput = "";

        private onEnterkeyDown(event: Event): void {
            if (event.target instanceof HTMLInputElement) {
                const el = event.target as HTMLInputElement;
                this.$emit("onEnterkeyDown", el.value);  
            }
        }

        private onClearButton(): void {
            this.strInput = "";
        }
    }
</script>

<style scoped>
    /* 虫眼鏡アイコン */
    .searchIcon {
        padding-left: 32px !important;
        background-image: url('../../assets/img/search_gy.svg');
        background-repeat: no-repeat;
        background-position: left 4px center;
        background-color: rgba(255, 255, 255, 0.4);
        background-blend-mode: lighten;
    }

    /* 虫眼鏡アイコン(フォーカス) */
    .searchIcon:focus {
            background-blend-mode: luminosity;
        }

    /* クリアボタン */
    .clearButton {
        padding-left: 32px !important;
        background-image: url('../../assets/img/delete_gy.svg');
        background-repeat: no-repeat;
        background-position: right 4px center;
        background-color: rgba(255, 255, 255, 0.4);
        background-blend-mode: lighten;
        position: absolute;
        height: 30px;
        width: 30px;
        right: 0;
        margin: 1px 17px 0px 0px;
        border: none;
    }

    /* クリアボタン(フォーカス) */
    .searchIcon:focus + .clearButton {
        background-color: #C9E8FF;
        background-blend-mode: luminosity;
    }

</style>
